<template>
  <div class="dictionary-base">
    <data-table ref="dataTable" :option="option">
      <template slot="mySlot">
        <upLoadImage v-model="backUrl" mode="image" :vlaue="backUrl" />
      </template>
    </data-table>
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";
import upLoadImage from "@/components/tools/upLoadImage";

export default {
  components: {
    DataTable,
    upLoadImage
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      option: {},
      apiOptions: {},
      extendData: "",
      backUrl: ""
    };
  },
  created() {
    const _this = this;
    _this.extendData = _this.data.treeSelect;

    _this.apiOptions = {
      api: "MaintenancePage_List",
      params: { Type: _this.data.treeSelect },
      addApi: "Maintenance_Add",
      getApi: "Maintenance_Get",
      editApi: "Maintenance_Edit",
      delApi: "Maintenance_Del"
    };

    _this.option = {
      form: {
        title: "房态图标", //表单标题
        width: 900, //宽度
        content: [
          {
            label: "名称",
            name: "Name",
            props: {
              disabled: true
            }
          },
          {
            label: "图标",
            slot: "mySlot"
          }
        ],
        edit: {
          infoApi: _this.apiOptions.getApi,
          submitApi: _this.apiOptions.editApi,
          onOpenAfter: res => {
            _this.backUrl = res.Data.Value;
          },
          onSubmitBefore: values => {
            values.Value = _this.backUrl;
            values.Type = _this.extendData;
            return values;
          }
        }
      },
      grid: {
        api: _this.apiOptions.api, //数据表格api
        params: { Type: _this.data.treeSelect },
        columns: [
          {
            title: "序号",
            width: "50px", //宽度
            align: "center", //对齐方式
            type: "indexcolumn" // 类型，indexcolumn = 序号
          },
          {
            title: "名称",
            dataIndex: "Name",
            align: "center"
          },
          {
            title: "图标",
            dataIndex: "Value",
            align: "center",
            customRender: (text, record) => {
              return (
                <a-avatar
                  shape="square"
                  src={record.Value}
                  style={{
                    border: "1px solid #ddd"
                  }}
                />
              );
            }
          },
          {
            title: "操作",
            dataIndex: "Id",
            width: "160px",
            key: "action",
            align: "center",
            scopedSlots: { customRender: "rowAction" } //插槽
          }
        ]
      }
    };
  },
  methods: {}
};
</script>

<style></style>
